// extracted by mini-css-extract-plugin
export default {"wrapper":"customerRegions_wrapper__OLt8B"};